import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Paper,
  Divider,
  Chip,
  CircularProgress,
  Button,
} from "@mui/material";
import { motion } from "framer-motion";
import AdminDashboardLayout from "../layout/AdminDashboardLayout";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { getOrderById } from "../../../services/adminService";

export default function OrderDetails() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const { data } = await getOrderById(id);
        setOrder(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching order:", error);
        setLoading(false);
      }
    };
    fetchOrder();
  }, [id]);

  if (loading) {
    return (
      <AdminDashboardLayout>
        <Box display="flex" justifyContent="center" mt={6}>
          <CircularProgress />
        </Box>
      </AdminDashboardLayout>
    );
  }

  if (!order) {
    return (
      <AdminDashboardLayout>
        <Typography color="error" mt={6} textAlign="center">
          Order not found.
        </Typography>
      </AdminDashboardLayout>
    );
  }

  return (
    <AdminDashboardLayout>
      <Box p={4}>
        <Button
          variant="text"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
          sx={{ mb: 2 }}
        >
          Back
        </Button>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Paper elevation={3} sx={{ borderRadius: 3, p: 4, maxWidth: 700, mx: "auto" }}>
            <Typography variant="h4" fontWeight="bold" gutterBottom>
              🧾 Order Details
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Box mb={2}>
              <Typography variant="subtitle2" color="text.secondary">
                Order ID
              </Typography>
              <Typography variant="body1">{order._id}</Typography>
            </Box>

            <Box mb={2}>
              <Typography variant="subtitle2" color="text.secondary">
                User Name
              </Typography>
              <Typography variant="body1">
                {order.userId?.firstName} {order.userId?.lastName}
              </Typography>
            </Box>

            <Box mb={2}>
              <Typography variant="subtitle2" color="text.secondary">
                Email
              </Typography>
              <Typography variant="body1">{order.userId?.email}</Typography>
            </Box>

            <Box mb={2}>
              <Typography variant="subtitle2" color="text.secondary">
                Plan Selected
              </Typography>
              <Chip label={order.planId || "Free Plan"} color="primary" />
            </Box>

            <Box mb={2}>
              <Typography variant="subtitle2" color="text.secondary">
                Payment Data
              </Typography>
              <Typography variant="body1">
                {order.paymentData && order.paymentData !== "null"
                  ? order.paymentData
                  : "Not Available"}
              </Typography>
            </Box>

            <Box mb={2}>
              <Typography variant="subtitle2" color="text.secondary">
                Session ID
              </Typography>
              <Typography variant="body1">{order.sessionId || "Not Available"}</Typography>
            </Box>

            <Box>
              <Typography variant="subtitle2" color="text.secondary">
                Created At
              </Typography>
              <Typography variant="body1">
                {new Date(order.createdAt).toLocaleString()}
              </Typography>
            </Box>
          </Paper>
        </motion.div>
      </Box>
    </AdminDashboardLayout>
  );
}